module.exports = __webpack_public_path__ + "assets/public/imgs/network-policy-samples/5-web-allow-external.svg";